module.exports = __webpack_public_path__ + "static/img/4-12.5709055.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/zoology/4-12.png
// module id = Lot4
// module chunks = 15